<script>
  import TableComponent from '@tasks/components/tasks/table';
  import FilterComponent from '@tasks/components/tasks/table-filter';
  import { mapGetters } from 'vuex';
  import { TaskModalService } from '@tasks/modals/TaskModalService';
  import { IntegrateModalService } from '@administration/modals/IntegrateModalService';

  export default {
    components: { TableComponent, FilterComponent },
    computed: {
      ...mapGetters('core/auth', ['user', 'integrate'])
    },
    created() {
      if (this.$route.meta.modal)
        TaskModalService.create().on('success', () => this.getAsyncData());
    },
    methods: {
      create_task() {
        this.integrate
          ? this.$router.push({ name: 'project.tasks.create'})
          : IntegrateModalService.create();
      }
    }
  };
</script>

<template>
  <layout-content>
    <v-btn
      v-if="user.role !== 'user'"
      slot="top-buttons"
      class="top-buttons"
      fab
      dark
      small
      color="#394858"
      @click="create_task"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
    <filter-component :with_project_filter="true" />
    <table-component />
  </layout-content>
</template>
